import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import EquityMarketAdminPanelOfferItem from './EquityMarketAdminPanelOfferItem';
import { useEquityMarketAdminPanel } from '../context/EquityMarketAdminPanelContext';
import { tabs } from '../constants/Tabs';

const BuyOffersTab: FC = () => {
  const { t } = useTranslate();

  const { data } = useEquityMarketAdminPanel();

  const isActive = data.selectedTab === tabs.BUY;

  return (
    <div
      className={`tab-pane fade ${isActive ? 'show active' : ''}`}
      role="tabpanel"
    >
      <div className="card card-bordered mb-4">
        <div className="card-inner">
          <h6 className="card-title mb-3">
            <em className="icon ni ni-wallet-in text-primary mr-2" />
            {t('AllBuyOffers')}
          </h6>
          <p className="text-soft fs-13px mb-4">
            {t('OffersTabDescriptionBuy')}
          </p>
          {data.tradingOffers.length === 0 ? (
            <div className="text-center py-4">
              <em className="icon ni ni-inbox fs-3 text-soft d-block mb-2" />
              <p className="text-soft">{t('NoOffersAvailable')}</p>
            </div>
          ) : (
            <div className="row g-3">
              {data.tradingOffers.map((offer) => (
                <EquityMarketAdminPanelOfferItem
                  key={offer._id}
                  offer={offer}
                  isSell={false}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BuyOffersTab;
